import type { TOC } from '@ember/component/template-only';
import { pageTitle } from 'ember-page-title';

interface CoachSignature {
  Args: {
    model: unknown;
    controller: unknown;
  };
}

<template>
  {{pageTitle "Coach"}}
  <div class="container py-5">
    <div class="alert alert-danger" role="alert">
      You are not registered as a coach. If you believe this is an error, please
      email
      <a href="mailto:v-support@hultashridge.com">v-support@hultashridge.com</a>
    </div>
  </div>
</template> satisfies TOC<CoachSignature>;
